import { createGreasemapClient, type GreasemapClient } from '@greasemap/api-client';
import type { AuthConfig } from '../auth/config';

/**
 * Builds the API client for the current authentication mode.
 *
 * @param config - Resolved authentication settings.
 * @param getAccessToken - Supplies an MSAL access token; unused in development mode.
 * @returns A configured client.
 */
export function buildApiClient(
  config: AuthConfig,
  getAccessToken?: () => Promise<string | undefined>,
): GreasemapClient {
  // Same-origin: the Vite dev server proxies /api to the ASP.NET Core host, and in production the
  // SPA is served from the same origin as the API.
  const baseUrl = window.location.origin;

  if (config.mode === 'development') {
    return createGreasemapClient({
      baseUrl,
      defaultHeaders: {
        'X-Dev-Subject': config.developmentIdentity.subject,
        'X-Dev-Name': config.developmentIdentity.name,
        // Only sent when set, so a developer can exercise the organiser/admin paths locally.
        ...(config.developmentIdentity.role === undefined
          ? {}
          : { 'X-Dev-Role': config.developmentIdentity.role }),
      },
    });
  }

  return createGreasemapClient({
    baseUrl,
    ...(getAccessToken ? { getAccessToken } : {}),
  });
}
